<ag-shr-modal-window
  #statusActivityModalRef
  [title]="title"
  [width]="500"
  [height]="'auto'"
  [inProgress]="inProgress$ | async"
  [showSaveButton]="showSaveButton$ | async"
  [onCloseModal]="handleClosePopup"
  (onSaveClick)="handleSaveApproveDenyReason($event)"
>
  <dx-form
    *ngIf="statusActivityModalRef?.popupComponent?.visible ?? false"
    #statusActivityFormRef
    [(formData)]="approveDenyReasonFormData"
    labelMode="floating"
  >
    <dxi-item
      [dataField]="BaseModelKeys.createdBy"
      [label]="{ text: 'Created By' }"
      [editorOptions]="{
        readOnly: true,
        placeholder: ''
      }"
    ></dxi-item>

    <dxi-item
      [dataField]="BaseModelKeys.createdDate"
      [label]="{ text: 'Created Date' }"
      editorType="dxDateBox"
      [editorOptions]="{
        readOnly: true,
        displayFormat: Constants.DISPLAY_DATE_TIME_FORMAT,
        useMaskBehavior: true,
        type: 'datetime'
      }"
    ></dxi-item>

    <dxi-item
      [dataField]="ApproveDenyReasonKeys.visibilityLevel"
      [label]="{ text: 'View Type' }"
      editorType="dxSelectBox"
      [editorOptions]="{
        readOnly: !(showSaveButton$ | async) || isVisibilityTypeLocked,
        items: approveDenyReasonVisibilityLevelLookup,
        valueExpr: 'value',
        displayExpr: 'description',
        searchEnabled: true,
        placeholder: ''
      }"
    ></dxi-item>

    <dxi-item
      [dataField]="ApproveDenyReasonKeys.activity"
      [isRequired]="true"
      [label]="{ text: 'Activity' }"
      [editorType]="'dxTextArea'"
      [editorOptions]="{ readOnly: !(showSaveButton$ | async), height: 150 }"
    ></dxi-item>
  </dx-form>
</ag-shr-modal-window>
